<div class="biomass-benchmark-card">
  <h2 class="widget-title">{{ 'TGA.Advice.Cultivation.BiomassBenchmark.Title' | translate }}</h2>

  @if (dataState().state === 'error') {
    <p class="error-message">{{ errorMessageKey() | translate }}</p>
  } @else if (chartModel()) {
    @if (chartOptions(); as options) {
      @if (subtitle()) {
        <p class="subtitle">{{ subtitle() }}</p>
      }

      <div class="chart-container" [attr.aria-label]="'TGA.Advice.Cultivation.BiomassBenchmark.AriaLabel' | translate">
        <agr-chart [dataSource]="chartSeries()" [options]="options" />
      </div>
    }
  } @else {
    <app-empty-widget [text]="'TGA.Advice.Cultivation.BiomassBenchmark.Empty' | translate" />
  }
</div>
